import { lazy } from 'react';
import Loadable from 'components/Loadable';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));

const LoginRoutes = {
  path: '/auth',
  children: [
    {
      path: 'login',
      element: <LoginPage />
    }
  ]
};

export default LoginRoutes;
